/**
 * Стартовые подсказки AI-коуча, общие для ERP-чата и Mini App.
 *
 * Основной источник — `/coach/suggested-prompts` (подсказки под фазу и роль
 * сотрудника). Этот список — запасной: он показывается, когда сервер подсказок
 * не отдал.
 */

export const COACH_FALLBACK_PROMPTS = [
    'Как подготовиться к 1-on-1 с руководителем?',
    'Что почитать, чтобы вырасти в моей роли?',
    'Как организовать рабочую неделю продуктивнее?',
]
